import React from 'react'
import { Button, Stack } from '@mui/material'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { InfoText } from '@e3dc-react/shell/Elements/InfoText'
import { UserContactInfo } from 'src/State/User/UserModel'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useUserRoles } from 'src/Hooks/user'
import { useNavigate } from 'react-router-dom'

/**
 * display data of the owner of a planned installation.
 */
const OwnerDisplay: React.FC<Props> = ({ userData, userId }) => {
  const { t } = useCustomTranslation()
  const { isServiceUser } = useUserRoles()
  const navigate = useNavigate()

  const goToProfile = (): void => {
    navigate(`/overview/users/${userId}`)
  }

  return (
    <>
      <Stack
        sx={{ backgroundColor: 'grey.grey07', py: 2, px: 4, borderRadius: 1, border: '1px solid', borderColor: 'grey.grey06', width: '100%' }}
        direction={{ xs: 'column', md: 'row' }}
        gap={2}
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', md: 'center' }}
      >
        <Typography>{'installation-configuration.owner-settings.user-data'}</Typography>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          flexWrap={'wrap'}
          gap={4}
          width={{ xs: '100%', md: '50%' }}
          justifyContent={{ xs: 'space-between', md: 'space-evenly' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
        >
          <InfoText title={'common.username'} value={userData?.username || '-'} titleTop={true} titleVariant={'subtitle2'} valueVariant={'body2'} />
          <InfoText title={'common.firstName'} value={userData?.firstName || '-'} titleTop={true} titleVariant={'subtitle2'} valueVariant={'body2'} />
          <InfoText title={'common.lastName'} value={userData?.lastName || '-'} titleTop={true} titleVariant={'subtitle2'} valueVariant={'body2'} />
          <InfoText title={'common.phone'} value={userData?.phone || '-'} titleTop={true} titleVariant={'subtitle2'} valueVariant={'body2'} />
        </Stack>
      </Stack>
      {isServiceUser && (
        <Stack justifyContent={'flex-end'} alignItems={'center'} direction={'row'} sx={{ width: '100%', my: 1 }}>
          <Button variant={'text'} disabled={!userId} onClick={goToProfile}>
            {t('installation-configuration.owner-settings.user-data.to-profile')}
          </Button>
        </Stack>
      )}
    </>
  )
}

interface Props {
  userData?: UserContactInfo
  userId?: number
}

export default OwnerDisplay
